import api from "../../utils/apiUser";

export const getMarcasPublic = async () => {
  const res = await api.get("/api/public/marcas");
  return res.data;
};
